const RewardsApiConstants = {
    REWARDS_URL: 'rewards-profile',
    CAM_BASE: 'accounts',
    REWARDS_HISTORY: 'rewards-history',
    ACTIVITY_HISTORY: 'activity-history',
    POINTS_CARD: 'points-card',
    REWARD_BASE: 'rewards',
    TRANSACTION_DETAILS: 'transaction',
    TRANSACTIONS: 'transactions',
    MISSING_POINTS: 'missingPoints',
    SYNCHRONY: 'syf',
    CREDIT_APPLICATION: 'credit-application',
    WALLET: 'wallet',
};

export default RewardsApiConstants;
